import { render, staticRenderFns } from "./editCurrency.vue?vue&type=template&id=2cdc515e&scoped=true&"
import script from "./editCurrency.vue?vue&type=script&lang=js&"
export * from "./editCurrency.vue?vue&type=script&lang=js&"
import style0 from "./editCurrency.vue?vue&type=style&index=0&id=2cdc515e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc515e",
  null
  
)

export default component.exports